import React from 'react'
import { Button, FormControl, MenuItem, Select, TextField } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { AGENT_SOURCE_OPTIONS, AGENT_STATUS_OPTIONS } from './constants'
import { AgentFiltersEnum } from './enums'
import { FilterToAdd } from './types'
interface Props {
  onSubmit: (newFilter: FilterToAdd) => void
}

export default function FilterInput(props: Props) {
  const { t } = useTranslation()
  const { handleSubmit, control, watch, resetField, reset } =
    useForm<FilterToAdd>({
      mode: 'onChange',
      defaultValues: { value: '', type: '' },
    })
  const { onSubmit } = props

  const handleLocalSubmit = (data: FilterToAdd) => {
    onSubmit(data)
    reset()
  }

  const watchType = watch('type')

  React.useEffect(() => {
    resetField('value')
  }, [watchType])

  return (
    <form onSubmit={handleSubmit(handleLocalSubmit)}>
      <Controller
        render={({ field, fieldState: { error } }) => (
          <FormControl size="small" sx={{ m: 1, minWidth: 120 }}>
            <Select
              error={!!error}
              {...field}
              displayEmpty
              inputProps={{ 'aria-label': 'Filter' }}
            >
              <MenuItem disabled value={AgentFiltersEnum.selectFilter}>
                <em>{t('tables.agents.filters.selectFilter')}</em>
              </MenuItem>
              <MenuItem value={AgentFiltersEnum.status}>
                {t('tables.agents.filters.status')}
              </MenuItem>
              <MenuItem value={AgentFiltersEnum.name}>
                {t('tables.agents.filters.name')}
              </MenuItem>
              <MenuItem value={AgentFiltersEnum.source}>
                {t('tables.agents.filters.source')}
              </MenuItem>
              <MenuItem value={AgentFiltersEnum.externalId}>
                {t('tables.agents.filters.externalId')}
              </MenuItem>
              <MenuItem value={AgentFiltersEnum.email}>
                {t('tables.agents.filters.email')}
              </MenuItem>
            </Select>
          </FormControl>
        )}
        name="type"
        control={control}
        rules={{
          required: true,
        }}
      />
      <Controller
        render={({ field, fieldState: { error } }) => (
          <span>
            {watchType === AgentFiltersEnum.status ? (
              <FormControl size="small" sx={{ m: 1, minWidth: 150 }}>
                <Select
                  error={!!error}
                  {...field}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Status' }}
                >
                  {AGENT_STATUS_OPTIONS.map((status) => {
                    return (
                      <MenuItem
                        key={status?.value}
                        disabled={status?.value === ''}
                        value={status?.value}
                      >
                        {t(status.label)}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            ) : watchType === AgentFiltersEnum.source ? (
              <FormControl size="small" sx={{ m: 1, minWidth: 150 }}>
                <Select
                  error={!!error}
                  {...field}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Status' }}
                >
                  {AGENT_SOURCE_OPTIONS.map((status) => {
                    return (
                      <MenuItem
                        key={status?.value}
                        disabled={status?.value === ''}
                        value={status?.value}
                      >
                        {t(status.label)}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            ) : (
              <FormControl size="small" sx={{ m: 1, minWidth: 150 }}>
                <TextField
                  error={!!error}
                  size="small"
                  id="outlined-basic"
                  variant="outlined"
                  disabled={!watchType}
                  {...field}
                />
              </FormControl>
            )}{' '}
          </span>
        )}
        name="value"
        control={control}
        rules={{
          required: true,
        }}
      />
      <FormControl size="small" sx={{ m: 1, minWidth: 150 }}>
        <Button
          sx={{ color: '#000', textTransform: 'none' }}
          variant="contained"
          type="submit"
        >
          {t('tables.agents.filters.add')}
        </Button>
      </FormControl>
    </form>
  )
}
